import Popper from 'popper.js'

$(function() {
  var contextPopper

  $('body').on('contextmenu', '[data-context-menu]', function(e) {
    var $reference = $(this),
      $popper = $('#context-menu')

    var ref = {
      getBoundingClientRect: function() {
        return {
          top: e.clientY,
          right: e.clientX,
          bottom: e.clientY,
          left: e.clientX,
          width: 0,
          height: 0,
        }
      },
      clientWidth: 0,
      clientHeight: 0,
    }

    contextPopper = new Popper(ref, $popper[0], {
      modifiers: {
        flip: {
          enabled: false,
        },
        offset: {
          offset: '50%p, -50%p',
        },
      },
      onCreate: function(data) {
        var $contextMenu = $(data.instance.popper).html(
          '<p class="context-menu__status">Loading...</p>',
        )
        data.instance.update()
        $.ajax($reference.attr('data-context-menu'), {
          dataType: 'json',
        }).then(
          function(value) {
            $contextMenu.html(value.html)
            data.instance.update() // update to reposition popper
            $contextMenu.trigger('bless')
          },
          function() {
            console.error('Failed')
          },
        )
        $contextMenu.addClass('active popper')
      },
      onUpdate: function(data) {
        console.log('on update: ', data)
      },
    })

    return false
  })

  $('body').on('click modal.show', function(e) {
    $('.popper').each(function(i, el) {
      hidePopover(el, e)
    })
  })

  function hidePopover(el, e) {
    if (
      !$(el).is(e.target) &&
      $(el).has(e.target).length === 0 &&
      $('.popover').has(e.target).length === 0
    ) {
      $(el).removeClass('active')
      contextPopper.destroy()
    }
  }
})
